import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useContext, Slot } from "@builder.io/qwik";
import { FloatingPopover } from "./floating.qwik.mjs";
import { HPopoverPanelImpl } from "./popover-panel-impl.qwik.mjs";
import { popoverContextId } from "./popover-context.qwik.mjs";
const HPopoverPanel = component$((props) => {
  const context = useContext(popoverContextId);
  if (context.floating) {
    return /* @__PURE__ */ jsx(FloatingPopover, {
      "data-floating": true,
      ...props,
      children: /* @__PURE__ */ jsx(Slot, {})
    });
  }
  return /* @__PURE__ */ jsx(HPopoverPanelImpl, {
    ...props,
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HPopoverPanel
};
